import { ErrorBoundary } from 'react-error-boundary';
import { useMediaQuery } from 'react-responsive';
import { Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '@repo/services/auth';
import { deviceSizes } from '@repo/styles';
import { QueryErrorResetBoundary } from '@tanstack/react-query';
import styled from 'styled-components';

// import MainHeader from 'components/header/Header';
import { auth } from 'services/firebase';
import http from 'services/http';
import { checkIsLogin, removeTokenCookie } from 'utils/auth';

import GeneralErrorBoundaryUI from 'components/errorBoundary/GeneralErrorBoundaryUI';
import MainFooter from 'components/footer/Footer';
import MainHeader from 'components/header/MainHeader';

const MainLayout = () => {
  const { pathname } = useLocation();
  const isMobile = useMediaQuery({ minWidth: deviceSizes.small });
  const isLaptop = useMediaQuery({ minWidth: deviceSizes.medium + 1 });
  const isDesktop = useMediaQuery({ minWidth: deviceSizes.large + 1 });
  const isXLarge = useMediaQuery({ minWidth: deviceSizes.xLarge + 1 });
  const device = { isMobile, isLaptop, isDesktop, isXLarge };
  const { logout } = useAuth({ auth: auth, http: http });
  const isLogin = checkIsLogin();

  const handleLogin = () => {
    const redirectUrl = import.meta.env.VITE_APP_CHAT_URL;
    const _redirectUrl = import.meta.env.VITE_APP_ENV === 'local' ? 'http://localhost:3000' : redirectUrl;

    // console.log(_redirectUrl);
    // window.location.href = `${_redirectUrl}/sign-in?callbackUrl=${window.origin}`;
    // window.location.href = `http://localhost:3000/sign-in?callbackUrl=${window.origin}`;
  };

  const handleLogout = async () => {
    // 상위 도메인에서 쿠키를 제거 후 하위 도메인(reward)로 이동
    // 쿠키 특성 상 하위 도메인에서 상위 도메인의 쿠키를 제거할 수 없으므로, 상위 도메인 이동 후, 쿠키 제거 후에 하위 도메인으로 이동한다.
    const redirectUrl = import.meta.env.VITE_APP_CHAT_URL;
    window.location.href = `${redirectUrl}`;

    const cookieDomain = import.meta.env.VITE_APP_COOKIE_DOMAIN;
    removeTokenCookie(cookieDomain);

    const rewardURL = import.meta.env.VITE_APP_REWARD_URL;
    window.location.href = `${rewardURL}`;
    await logout();
  };

  return (
    <>
      <SLayoutWrapper>
        <SContentWrapper>
          <MainHeader isLogin={isLogin} onLogout={handleLogout} onLogin={handleLogin} />
          <QueryErrorResetBoundary>
            {({ reset }) => (
              <ErrorBoundary key={pathname} onReset={reset} FallbackComponent={GeneralErrorBoundaryUI}>
                <Outlet context={{ device }} />
              </ErrorBoundary>
            )}
          </QueryErrorResetBoundary>
          <MainFooter isDesktop={device.isDesktop} />
        </SContentWrapper>
      </SLayoutWrapper>
    </>
  );
};

const SLayoutWrapper = styled.section`
  padding: 24px 80px;
  min-height: 100dvh;
  width: 100vw;
  overflow-x: hidden;
  min-width: 280px;
  background-color: ${({ theme }) => theme.color.field.background};

  @media ${({ theme }) => theme.device.large} {
    padding: 24px 40px;
  }

  @media ${({ theme }) => theme.device.medium} {
    padding: 24px 16px;
  }
`;

const SContentWrapper = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 40px;
  max-width: 1280px;
`;

export default MainLayout;
